import type { CheckboxProps as ChordsCheckboxProps } from '~/chords/Checkbox';
import { Checkbox as ChordsCheckbox } from '~/chords/Checkbox';
import type { ContainerComponentProps } from '~/components/WithClassNameHoc';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export type CheckboxProps = ContainerComponentProps<ChordsCheckboxProps>;
export const Checkbox = withClassNameHoc(ChordsCheckbox);
